module.exports = __webpack_public_path__ + "img/secciones.00634d73.png";